import React, { useEffect, useState } from "react";
import alertify from "alertifyjs";
import useFetchData from "../../hooks/useFetchData";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { t } from "i18next";

const CommonMultiSelect = ({
  id,
  label,
  valueField,
  textField,
  onChange,
  fetchUrl,
  required,
  disabled,
  opened,
  selectAll = false,
}) => {
  const { data, loading, error } = useFetchData(fetchUrl);
  const [value, setValue] = useState([]);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  useEffect(() => {
    if (
      !hasUserInteracted &&
      data &&
      data.length > 0 &&
      selectAll &&
      value.length === 0
    ) {
      const allValues = data.map((item) => item[valueField]);
      setValue(allValues);
      onChange({ value: data });
    }
  }, [data, valueField, onChange, selectAll, value.length, hasUserInteracted]);

  useEffect(() => {
    if (error) {
      alertify.error(error);
    }
  }, [error]);

  const handleChange = (event) => {
    setValue(event.value.map((item) => item[valueField]));
    setHasUserInteracted(true);
    onChange(event);
  };

  return (
    <MultiSelect
      name={id}
      id={id}
      label={label ? label : undefined}
      style={{ width: "100%" }}
      data={data}
      value={data?.filter((item) => value.includes(item[valueField]))}
      dataItemKey={valueField}
      textField={textField}
      onChange={handleChange}
      loading={loading}
      required={required}
      disabled={disabled}
      placeholder={t("please_select")}
      opened={opened}
    />
  );
};

export default CommonMultiSelect;
